import { NgModule } from '@angular/core';
import { AccredibleCookiesService } from './cookies.service';

@NgModule({
  providers: [AccredibleCookiesService],
})
export class AccredibleCookiesServiceModule {}
